import { getPayRange } from "@/api/payRangeAPI";
import { listSubscriptionsForPosition } from "@/api/positionPayRangeSubscriptionAPI";
import {
  hasCurrentPayPlanDetail,
  mapCurrentPayPlanCard,
  pickCurrentSubscription,
} from "@components/CurrentPayPlanCard/mapCurrentPayPlanCard";

/**
 * Fill pay-range / position fields that the Pay Plans list row does not carry.
 * Subscription lookup is best-effort — a missing position must not hide the plan.
 */
export async function enrichCurrentPayPlanCard(row) {
  const card = mapCurrentPayPlanCard({ row });
  if (!hasCurrentPayPlanDetail(row)) return card;

  const positionId = row.primaryPosition?.id;
  if (!positionId) return card;

  try {
    const subscriptionResponse = await listSubscriptionsForPosition(positionId);
    const subscription = pickCurrentSubscription(subscriptionResponse?.data);
    if (!subscription) return card;

    const payRangeId = subscription.payRangeId || subscription.pay_range_id;
    let payRange = null;
    if (payRangeId) {
      try {
        const payRangeResponse = await getPayRange(payRangeId);
        payRange = payRangeResponse?.data || null;
      } catch {
        payRange = null;
      }
    }

    return mapCurrentPayPlanCard({ row, subscription, payRange });
  } catch {
    return card;
  }
}
